import React from "react";
import PropTypes from "prop-types";

function CustomerPersonalDetail({ job }) {
  const { address } = job;
  const addressLines = [
    address.address1,
    address.address2,
    address.address3,
    address.city,
    address.county,
    address.postcode,
  ].filter((line) => line && line.length > 0);

  return (
    <div className="col-md-4">
      <div className="mb-3">
        <small
          className="text-muted text-uppercase fw-semibold"
          style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}
        >
          Address
        </small>
        <address className="mb-0" style={{ fontStyle: "normal" }}>
          {addressLines.map((line, i) => (
            <p key={i} className="mb-0 fw-medium">
              {line}
            </p>
          ))}
        </address>
      </div>
      <div className="mb-3">
        <small
          className="text-muted text-uppercase fw-semibold"
          style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}
        >
          Email
        </small>
        <p className="mb-0 fw-medium">
          <a href={`mailto:${job.email}`}>{job.email}</a>
        </p>
      </div>
      <div className="mb-3">
        <small
          className="text-muted text-uppercase fw-semibold"
          style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}
        >
          Mobile Number
        </small>
        <p className="mb-0 fw-medium">
          <a href={`tel:${job.mobileNumber}`}>{job.mobileNumber}</a>
        </p>
      </div>
    </div>
  );
}

CustomerPersonalDetail.propTypes = {
  job: PropTypes.object.isRequired,
};

export default CustomerPersonalDetail;
